import { Box, styled, Button, Modal } from '@mui/material'
import { useUserAssets } from 'state/user/hooks'
import { useInsufficientBalanceModalToggle, useModalOpen } from 'state/application/hooks'
import { ApplicationModal } from 'state/application/reducer'
import 'pages/Nft/assets/font.css'
// import Modal from 'components/Modal'
import MyBalance from 'pages/UserCenter/components/MyBalanceNewUI'
import CloseSvg from 'assets/images/svg/close.svg'

// new style
const ModalMain = styled(Box)`
  width: 542px;
  padding: 40px;
  background: linear-gradient(45deg, #1d131e, #000000, #11042d);
  border-radius: 36px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`
const MainHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    font-family: 'Poppins', 'Roboto Condensed', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    color: #ffffff;
  }
  img {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
`
const SubTitle = styled(Box)`
  padding: 12px 0 25px;
  font-family: 'Poppins', 'Roboto Condensed', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  opacity: 0.7;
`
const LinkButtonBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
const LinkButton = styled(Button)`
  width: 223px !important;
  height: 60px;
  border-radius: 60px;
  font-size: 16px !important;
  font-family: 'Poppins', 'Roboto Condensed', sans-serif !important;
  font-style: normal;
  font-weight: 600 !important;
  font-size: 20px !important;
  border-width: 1px !important;
`

export default function InsufficientBalanceModal() {
  const assets = useUserAssets()
  const open = useModalOpen(ApplicationModal.INSUFFICIENT_BALANCE)
  const modalToggle = useInsufficientBalanceModalToggle()
  return (
    <Modal open={open} onClose={modalToggle}>
      <ModalMain>
        <MainHeader>
          <span>Insufficient balance</span>
          <img src={CloseSvg} alt="" onClick={modalToggle} />
        </MainHeader>
        <SubTitle>Your wallet balance is insufficient</SubTitle>
        {assets && assets.coinMsgList?.length > 0 && <MyBalance list={assets.coinMsgList}></MyBalance>}
        <Box mt={'40px'}></Box>
        <LinkButtonBox>
          <LinkButton onClick={() => window.open('/wallet/swap')} variant="outlined">
            Swap
          </LinkButton>
          <LinkButton onClick={() => window.open('/wallet/deposit')} variant="contained">
            Deposit
          </LinkButton>
        </LinkButtonBox>
      </ModalMain>
    </Modal>
  )
}
